module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy S5 Black.877e20c9.png";